// extracted by mini-css-extract-plugin
export default {"loadingContainer":"ALMLoader_loadingContainer__YNXW2"};